import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import routes from "../../../Utils/routes";
import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    Divider,
    Avatar,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Alert
} from "@mui/material";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DeleteIcon from '@mui/icons-material/Delete';
import LanguageIcon from '@mui/icons-material/Language';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import { updateExpressedInterest, createProspect } from "../../../Utils/apiService";
import { AuthContext } from "../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../interfaces/Contexts";
import { deleteBusiness, deactivateBusiness, createBusinessPromotionController } from "../../../Utils/apiService";
import P2PChatBox from "../../../GlobalComponents/ChatBox/P2Pchat";
import flame from "../../../Assets/flame.svg";
import { useSnackbar } from 'notistack';
import Frame2121453880 from '../../../Assets/promotionalBannar/Frame2121453880.png';
const styles = {
    title: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: 1.2
    },
    location: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#8C8E94'
    },
    sectionTitle: {
        fontSize: '18px',
        fontWeight: 600
    },
    bodyText: {
        fontSize: '14px',
        fontWeight: 400
    },
    linkText: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#2C60AA',
        textDecoration: 'underline'
    },
    infoText: {
        fontSize: '14px',
        fontWeight: 500
    },
    gradientButton: {
        background: 'linear-gradient(90deg, #00387A -30.21%, #006BB7 100%)',
        color: 'white',
        fontSize: '14px',
        fontWeight: 500,
        borderRadius: '8px',
        '&:hover': {
            background: 'linear-gradient(90deg, #00387A -20%, #006BB7 110%)'
        }
    },
    outlineButton: {
        color: '#2C60AA',
        fontSize: '14px',
        fontWeight: 500,
        borderColor: '#2C60AA',
        borderRadius: '8px',
        '&:hover': {
            borderColor: '#2C60AA',
            background: 'rgba(11, 62, 105, 0.04)'
        }
    },
    infoCard: {
        border: '1px solid #D1D4DB',
        background: '#F6F8FB',
        borderRadius: '16px',
        padding: 3
    },
    dialogTitle: {
        fontSize: '18px',
        fontWeight: 500
    },
    fieldLabel: {
        fontSize: '14px',
        fontWeight: 500
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: '0.5px solid #B2B3B7'
            }
        }
    }
};

interface BusinessData {
    Id: string;
    Name: string;
    Description?: string;
    Business_Type__c?: string;
    Phone?: string;
    Business_Email__c?: string;
    Hide_Business_Email__c?: boolean;
    Hide_Business_Phone__c?: boolean;
    Website?: string;
    Business_Address__c?: string;
    Location_URL__c?: string;
    Cover_Image_Url__c?: string;
    Logo_URL__c?: string;
    Is_Active__c?: boolean;
    Business_Approval__c?: string;
    RecordTypeId?: string;
    Business_Directories__r?: {
        totalSize: number;
        done: boolean;
        records: Array<{
            Business__c: string;
            Id: string;
            Contact__c: string;
            RecordTypeId: string;
            Contact__r: {
                Id: string;
                Name: string;
                Profile_Picture_URL__c?: string;
            }
        }>
    };
    Owner?: {
        Name: string;
        Avatar?: string;
    };
    attributes?: {
        type: string;
        url: string;
    };
    Is_Portal_Promotion_Allowed__c?: boolean;
    Promotion_Status__c?: string;
}

interface BusinessDetailPageProps {
    businessData: BusinessData | any;
    businessDirectoryTypes: Array<{ Name: string, Id: string }>;
    expressedBusinessInterests: any[];
    onBackClick: () => void;
    businessSource?: 'all' | 'my';
    onBusinessDeleted?: () => void;
    isMobile?: boolean;
    onPromotionSubmitted?: (businessId: string) => void; // <-- Add this
}

const BusinessDetailPage: React.FC<BusinessDetailPageProps> = ({
    businessData,
    onBackClick,
    businessDirectoryTypes,
    expressedBusinessInterests,
    businessSource,
    onBusinessDeleted,
    onPromotionSubmitted,
}) => {
    const navigate = useNavigate();
    console.log(businessData, "businessDatabusinessDatabusinessData");
    const [openDialog, setOpenDialog] = useState(false);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [confirmDeactivateOpen, setConfirmDeactivateOpen] = useState(false);
    const [isChatBoxOpen, setChatBoxOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState<string | null>(null);
    const [featureDialogOpen, setFeatureDialogOpen] = useState(false);
    const [featureSubject, setFeatureSubject] = useState("");
    const [featureMessage, setFeatureMessage] = useState("");
    const [promotionStatusDialogOpen, setPromotionStatusDialogOpen] = useState(false);
    const [promotionStatusMessage, setPromotionStatusMessage] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    console.log(businessData?.Id, "businessDirectoryTypes");
    console.log("Current business source:", businessSource);
    const { state: { user } } = useContext(AuthContext);
    const userData = user as AuthUser;

    if (!businessData) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography>No business data available</Typography>
                <Button onClick={onBackClick} sx={{ mt: 2 }}>
                    Back to listing
                </Button>
            </Box>
        );
    }

    const existingInterest = expressedBusinessInterests.find(
        interest => interest.Business__c === businessData.Id
    );
    const interestTimestamp = getInterestTimestamp(businessData.Id);
    const canExpressInterestAgain = !existingInterest || isThreeDaysPassed(interestTimestamp);

    const handleOpenDialog = () => {
        if (canExpressInterestAgain) {
            setOpenDialog(true);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSubject("");
        setMessage("");
        setStatusMessage("");
    };
    console.log(businessData, "businessData12345321345");
    
    const handleSubmit = async () => {
        if (!subject || !message) {
            setStatusMessage("Please fill all required fields");
            return;
        }
        setIsLoading(true);
        try {
            const prospectRecordTypeId = businessDirectoryTypes.find(
                type => type.Name === "Business_Prospect"
            )?.Id;
            if (!prospectRecordTypeId) {
                console.error('Business Prospect record type not found');
                setStatusMessage("Configuration error. Please try again later.");
                return;
            }
            if (existingInterest) {
                const response = await updateExpressedInterest(
                    existingInterest.Id,
                    true
                );
                enqueueSnackbar({ message: 'Request raised successfully', variant: 'success', autoHideDuration: 1000 });
                expressedBusinessInterests.push({
                    Id: response.id || response.Id,
                    Business__c: businessData.Id,
                    Expressed_Interest__c: true,
                });
            } else {
                const response = await createProspect({
                    businessId: businessData?.Id,
                    contactId: user?.applicantId || "",
                    message: message,
                    subject: subject,
                    recordTypeId:businessData?.RecordTypeId
                });
                enqueueSnackbar({ message: 'Request raised successfully', variant: 'success', autoHideDuration: 1000 });
                expressedBusinessInterests.push({
                    Id: response.id || response.Id,
                    Business__c: businessData.Id,
                    Expressed_Interest__c: true,
                });
            }
            setInterestTimestamp(businessData.Id); // Set timestamp on express
            handleCloseDialog();
            setStatusMessage("Interest expressed successfully");
        } catch (error) {
            console.error('Error creating prospect:', error);
            setStatusMessage("Error expressing interest. Please try again.");
            enqueueSnackbar({ message: 'Request raised failed', variant: 'error', autoHideDuration: 1000 });
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditBusiness = () => {
        navigate(routes.createbusinessdirectory, {
            state: {
                isEdit: true,
                businessData: businessData
            }
        });
    };

    const handleDeleteBusiness = async () => {
        if (!businessData?.Id) return;

        setIsLoading(true);
        try {
            const response = await deleteBusiness(businessData.Id);
            console.log('Business deleted:', response);

            if (response && !response.message) {
                if (onBusinessDeleted) {
                    onBusinessDeleted();
                }
                onBackClick();
            } else {
                setStatusMessage(response.message || "Error deleting business. Please try again.");
            }
        } catch (error) {
            console.error('Error deleting business:', error);
            setStatusMessage("Error deleting business. Please try again.");
        } finally {
            setIsLoading(false);
            setConfirmDeleteOpen(false);
        }
    };

    const handleToggleActivation = async () => {
        if (!businessData?.Id) return;

        setIsLoading(true);
        try {
            const response = await deactivateBusiness(businessData.Id);
            console.log('Business activation toggled:', response);

            if (response && !response.message) {
                if (businessData) {
                    businessData.Is_Active__c = !businessData.Is_Active__c;
                }
                setStatusMessage(
                    businessData?.Is_Active__c ?
                        "Business activated successfully" :
                        "Business deactivated successfully"
                );
            } else {
                setStatusMessage(response.message || "Error updating business status. Please try again.");
            }
        } catch (error) {
            console.error('Error toggling business activation:', error);
            setStatusMessage("Error updating business status. Please try again.");
        } finally {
            setIsLoading(false);
            setConfirmDeactivateOpen(false);
        }
    };

    const handleOpenChatBox = () => setChatBoxOpen(true);
    const handleCloseChatBox = () => setChatBoxOpen(false);

    const handleOpenFeatureDialog = () => setFeatureDialogOpen(true);

    const handleCloseFeatureDialog = () => {
        setFeatureDialogOpen(false);
        setFeatureSubject('');
        setFeatureMessage('');
    };

    const handleFeatureRequestSubmit = () => {
        const payload = {
            Business__c: businessData.Id,
            Prospect_Message__c: featureMessage,
            Subject__c: featureSubject
        }
        createBusinessPromotionController(payload).then((res) => {
            console.log(res, "res");
            onPromotionSubmitted?.(businessData.Id);
            handleCloseFeatureDialog();
            enqueueSnackbar({ message: 'Request sent successfully', variant: 'success', autoHideDuration: 1000 });


        }).catch((err) => {
            console.log(err, "err");
            handleCloseFeatureDialog();
            enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        })
    };

    const handleFeaturePromotionClick = () => {
        if (businessData?.Is_Portal_Promotion_Allowed__c) {
            setPromotionStatusMessage("Your business promotion is already live.");
            setPromotionStatusDialogOpen(true);
            return;
        }
        if (businessData?.Promotion_Status__c === "Submitted") {
            setPromotionStatusMessage("You have already submitted. Kindly wait for some time.");
            setPromotionStatusDialogOpen(true);
            return;
        }
        handleOpenFeatureDialog();
    };

    return (
        <Box sx={{ mb: 4 }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    mb: 4,
                    position: 'relative'
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        height: { xs: '200px', sm: '220px', md: '250px' },
                    }}
                >
                    <Box
                        component="img"
                        src={businessData.Cover_Image_Url__c || Frame2121453880}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                        alt={`${businessData.Name} cover`}
                    />

                    <Avatar
                        src={businessData.Logo_URL__c || ""}
                        alt={businessData.Name}
                        sx={{
                            position: 'absolute',
                            width: { xs: 120, sm: 160, md: 192 },
                            height: { xs: 120, sm: 160, md: 192 },
                            borderRadius: '50%',
                            border: '4px solid white',
                            bgcolor: '#f57c00',
                            boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
                            bottom: { xs: -60, sm: -80, md: -96 },
                            left: { xs: '50%', sm: '50%', md: 40 },
                            transform: { xs: 'translateX(-50%)', sm: 'translateX(-50%)', md: 'translateX(0)' },
                            zIndex: 1
                        }}
                    >
                        {businessData.Name ? businessData.Name.charAt(0) : ""}
                    </Avatar>

                    <Chip
                        label={businessData.Business_Type__c || "Business"}
                        sx={{
                            position: 'absolute',
                            top: 16,
                            right: 16,
                            bgcolor: 'white',
                            fontWeight: 500,
                            borderRadius: '20px'
                        }}
                    />
                </Box>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    padding: { xs: 2, sm: 2, md: 3 },
                    paddingTop: { xs: 8, sm: 10, md: 3 },
                    flexDirection: { xs: 'column', sm: 'column', md: 'row' }
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: { xs: 2, sm: 2, md: 0 },
                        marginLeft: { xs: 0, sm: 0, md: "15rem" },
                        width: { xs: '100%', sm: '100%', md: 'auto' },
                        justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' }
                    }}>
                        <Box sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' } }}>
                            <Typography sx={styles.title}>
                                {businessData.Name}
                            </Typography>
                            {businessSource === 'my' ?
                                <>
                                    {businessData.Business_Approval__c === "Approved" && (
                                        <Typography onClick={handleFeaturePromotionClick} style={{ fontWeight: "500", color: "rgb(0 87 189)", fontSize: "14px", textDecoration: "underline", cursor: "pointer" }}>
                                            <img src={flame} style={{ width: "17px", height: "17px" }} alt={businessData.Name} /> Feature in FLAME
                                        </Typography>
                                    )}
                                </>
                                :
                                <Typography sx={styles.location}>
                                    {businessData.Business_Address__c ? businessData.Business_Address__c.split(',')[0] : ""},
                                    {businessData.Business_Address__c ? businessData.Business_Address__c.split(',')[1] : ""}
                                </Typography>
                            }
                        </Box>
                    </Box>

                    <Box sx={{
                        marginLeft: { xs: 0, sm: 0, md: 'auto' },
                        display: 'flex',
                        gap: 1,
                        p:1,
                        mt: { xs: 2, sm: 2, md: 0 },
                        width: { xs: '100%', sm: '100%', md: 'auto' },
                        justifyContent: { xs: 'center', sm: 'center', md: 'flex-end' }
                    }}>
                        {businessSource === 'my' ? (
                            <>
                                {businessData.Business_Approval__c === "Approved" && (
                                    <>
                                        <Button
                                            variant="outlined"
                                            // sx={styles.outlineButton}
                                            onClick={() => setConfirmDeactivateOpen(true)}
                                        >
                                            {businessData.Is_Active__c ? "De-activate" : "Activate"}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            // sx={styles.gradientButton}
                                            style={{ color: "#5B4200" }}
                                            onClick={handleEditBusiness}
                                        >
                                            Edit business
                                        </Button>
                                        <IconButton
                                            color="error"
                                            onClick={() => setConfirmDeleteOpen(true)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </>
                                )}

                                {businessData.Business_Approval__c === "Pending" && (
                                    <>
                                        <IconButton
                                            color="error"
                                            onClick={() => setConfirmDeleteOpen(true)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                color: '#000000',
                                                background: "#FEEBBE",
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '12px',
                                                padding: '5px 10px',
                                                width: 'fit-content',
                                                textAlign: 'center'
                                            }}
                                        >
                                            In Review
                                        </Typography>

                                    </>
                                )}

                                {businessData.Business_Approval__c === "Rejected" && (
                                    <Typography sx={{
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        color: '#000000',
                                        mr: 2,
                                        background: "#F1BFBF",
                                        disaplay: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '12px',
                                        padding: '5px 10px 5px 10px',
                                    }}>
                                        Rejected
                                    </Typography>
                                )}
                            </>
                        ) : (
                            <>
                                <Button
                                    variant="text"
                                    onClick={() => {
                                        if (businessData.Location_URL__c) {
                                            const url = businessData.Location_URL__c.startsWith('http')
                                                ? businessData.Location_URL__c
                                                : `https://${businessData.Location_URL__c}`;
                                            window.open(url, '_blank', 'noopener,noreferrer');
                                        }
                                    }}
                                    sx={{
                                        color: '#2C60AA',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        textDecoration: 'underline',
                                        '&:hover': {
                                            background: 'rgba(11, 62, 105, 0.04)'
                                        }
                                    }}
                                >
                                    Get directions
                                </Button>
                                <Button
                                    sx={styles.gradientButton}
                                    style={{ color: "#fff", backgroundImage: "#2C60AA" }}
                                    onClick={handleOpenDialog}
                                    disabled={isLoading || !canExpressInterestAgain}
                                >
                                    {isLoading
                                        ? "Processing..."
                                        : canExpressInterestAgain
                                            ? "Express Interest"
                                            : "Interest Expressed"}
                                </Button>
                            </>
                        )}
                    </Box>
                </Box>
            </Paper>

            <Grid container spacing={3}>
                <Grid item xs={12} md={8} sx={{ textAlign: "start" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            borderRadius: '16px',
                            p: 3,
                            height: { xs: 'auto', md: '30vh' },
                            overflow: { xs: 'visible', md: 'auto' },
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                            },
                        }}
                    >
                        <Typography sx={styles.sectionTitle} gutterBottom>
                            About {businessData.Name}
                        </Typography>

                        <Typography
                            sx={{
                                ...styles.bodyText,
                                whiteSpace: 'pre-line',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word'
                            }}
                        >
                            {businessData.Description || "No description available."}
                        </Typography>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Paper
                        elevation={0}
                        sx={{
                            ...styles.infoCard,
                            mb: 3,
                            // height: { xs: 'auto', md: '30vh' },
                            overflow: { xs: 'visible', md: 'auto' },
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                            },
                        }}
                    >
                        <Box>
                            {businessData.Phone && !businessData.Hide_Business_Phone__c && (
                                <Box sx={{
                                    display: 'flex',
                                    py: 2,
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    alignItems: { xs: 'center', sm: 'flex-start' },
                                    textAlign: { xs: 'center', sm: 'left' }
                                }}>
                                    <Box sx={{ mr: { xs: 0, sm: 2 }, mb: { xs: 1, sm: 0 } }}>
                                        <Avatar sx={{ bgcolor: '#f5f5f5' }}>
                                            <PhoneIcon sx={{ color: '#666' }} />
                                        </Avatar>
                                    </Box>
                                    <Box>
                                        <Typography
                                            component="a"
                                            href={`tel:${businessData.Phone}`}
                                            sx={{
                                                ...styles.infoText,
                                                textDecoration: 'none',
                                                '&:hover': { textDecoration: 'underline' }
                                            }}
                                        >
                                            {businessData.Phone}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                            <Divider />

                            {businessData.Business_Address__c && (
                                <Box sx={{ display: 'flex', py: 2, justifyContent: "start", alignItems: "center" }}>
                                    <Box sx={{ mr: 2 }}>
                                        <Avatar sx={{ bgcolor: '#f5f5f5' }}>
                                            <LocationOnOutlinedIcon sx={{ color: '#666' }} />
                                        </Avatar>
                                    </Box>
                                    <Box>
                                        {businessData.Location_URL__c ? (
                                            <Typography
                                                component="a"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    let url = businessData.Location_URL__c;
                                                    if (!(url ?? "").match(/^https?:\/\//i)) {
                                                        url = `https://${url}`;
                                                    }
                                                    const link = document.createElement('a');
                                                    link.href = url || '';
                                                    link.target = '_blank';
                                                    link.rel = 'noopener noreferrer';
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                }}
                                                sx={{
                                                    ...styles.infoText,
                                                    textDecoration: 'none',
                                                    cursor: 'pointer',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                Business Location
                                            </Typography>
                                        ) : (
                                            <Typography sx={styles.infoText}>
                                                {businessData.Business_Address__c}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {businessData.Phone && (
                                <>
                                    <Divider />
                                    <Box sx={{ display: 'flex', py: 2, justifyContent: "start", alignItems: "center" }}>
                                        <Box sx={{ mr: 2 }}>
                                            <Avatar sx={{ bgcolor: '#f5f5f5' }}>
                                                <PhoneIcon sx={{ color: '#666' }} />
                                            </Avatar>
                                        </Box>
                                        <Box>
                                            <Typography
                                                component="a"
                                                href={`tel:${businessData.Phone}`}
                                                sx={{
                                                    ...styles.infoText,
                                                    textDecoration: 'none',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {businessData.Phone}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </>
                            )}
                            {businessSource === 'my' && businessData.Business_Email__c && (
                                <>
                                    <Box sx={{ display: 'flex', py: 2, justifyContent: "start", alignItems: "center" }}>
                                        <Box sx={{ mr: 2 }}>
                                            <Avatar sx={{ bgcolor: '#f5f5f5' }}>
                                                <EmailIcon sx={{ color: '#666' }} />
                                            </Avatar>
                                        </Box>
                                        <Box>
                                            <Typography
                                                component="a"
                                                href={`mailto:${businessData.Business_Email__c}`}
                                                sx={{
                                                    ...styles.infoText,
                                                    textDecoration: 'none',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {businessData.Business_Email__c}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Divider />
                                </>
                            )}
                            {businessData.Business_Email__c && !businessData.Hide_Business_Email__c && (
                                <>
                                    <Divider />
                                    <Box sx={{ display: 'flex', py: 2, justifyContent: "start", alignItems: "center" }}>
                                        <Box sx={{ mr: 2 }}>
                                            <Avatar sx={{ bgcolor: '#f5f5f5' }}>
                                                <EmailIcon sx={{ color: '#666' }} />
                                            </Avatar>
                                        </Box>
                                        <Box>
                                            <Typography
                                                component="a"
                                                href={`mailto:${businessData.Business_Email__c}`}
                                                sx={{
                                                    ...styles.infoText,
                                                    textDecoration: 'none',
                                                    '&:hover': { textDecoration: 'underline' }
                                                }}
                                            >
                                                {businessData.Business_Email__c}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </>
                            )}
                            {businessSource !== 'my' && (
                                <>
                                    <Divider sx={{ mt: 1, mb: 2 }} />

                                    <Typography sx={{
                                        ...styles.sectionTitle,
                                        textAlign: { xs: 'center', sm: 'left' }
                                    }} gutterBottom>
                                        Business owner
                                    </Typography>

                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        mt: 2,
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        textAlign: { xs: 'center', sm: 'left' }
                                    }}>
                                        <Avatar
                                            src={businessData.Business_Directories__r?.records[0]?.Contact__r?.Profile_Picture_URL__c || ""}
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                mr: { xs: 0, sm: 2 },
                                                mb: { xs: 1, sm: 0 }
                                            }}
                                        >
                                            <PersonIcon />
                                        </Avatar>
                                        <Typography sx={styles.infoText}>
                                            {businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Name ? businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Name : businessData?.Business_Email__c}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ mt: 3 }}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            sx={{
                                               
                                                ...styles.outlineButton,
                                                py: 1.5
                                            }}
                                            onClick={handleOpenChatBox}
                                        >
                                            {`Chat${businessData?.Name ? ` with ${businessData.Name}` : ''}`}                                        </Button>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Paper>
                </Grid>
            </Grid>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        margin: { xs: 2, sm: 'auto' },
                        width: { xs: 'calc(100% - 32px)', sm: '100%' }
                    }
                }}
            >
                <DialogTitle sx={{
                    borderBottom: '1px solid #D1D4DB',
                    ...styles.dialogTitle
                }}>
                    Get in touch with {businessData.Name}
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    <Typography sx={{ ...styles.fieldLabel, mb: 1 }}>
                        Subject<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Interested in your products..."
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        variant="outlined"
                        sx={styles.textField}
                        required
                        margin="normal"
                    />

                    <Typography sx={{ ...styles.fieldLabel, mb: 1, mt: 2 }}>
                        Your message<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Write your message here..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        variant="outlined"
                        sx={styles.textField}
                        required
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 1 }}>
                    <Button
                        onClick={handleCloseDialog}
                        sx={{
                            ...styles.fieldLabel,
                            color: 'text.secondary'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        sx={styles.gradientButton}
                        style={{
                            padding: "5px 20px", color: "#fff",
                            background: '#2C60AA !important',
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        p: 2,
                        margin: { xs: 2, sm: 'auto' },
                        width: { xs: 'calc(100% - 32px)', sm: '100%' }
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 600, fontSize: "16px",color:"#5B4200 !important" }}>
                    Delete Business
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete {businessData.Name}? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setConfirmDeleteOpen(false)}
                        sx={styles.outlineButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteBusiness}
                        variant="contained"
                        color="error"
                        disabled={isLoading}
                    >
                        {isLoading ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={confirmDeactivateOpen}
                onClose={() => setConfirmDeactivateOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        p: 2,
                        margin: { xs: 2, sm: 'auto' },
                        width: { xs: 'calc(100% - 32px)', sm: '100%' }
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 600, fontSize: "16px" }}>
                    {businessData.Is_Active__c ? "Deactivate" : "Activate"} Business
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to {businessData.Is_Active__c ? "deactivate" : "activate"} {businessData.Name}?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setConfirmDeactivateOpen(false)}
                        sx={styles.outlineButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleToggleActivation}
                        variant="contained"
                        sx={styles.gradientButton}
                        disabled={isLoading}
                    >
                        {isLoading ? "Processing..." : (businessData.Is_Active__c ? "Deactivate" : "Activate")}
                    </Button>
                </DialogActions>
            </Dialog>

            {isChatBoxOpen && (
                <P2PChatBox
                    onClose={handleCloseChatBox}
                    name={
                        businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Name
                            ? businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Name
                            : businessData?.Business_Email__c
                    }
                    avatarImg={businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Profile_Picture_URL__c || ""}
                    mentordetails={{
                        userId: userData?.applicantId,
                        otherUserId: businessData?.Business_Directories__r?.records?.[0]?.Contact__r?.Id,
                        chatid: undefined
                    }}
                />
            )}

            <Dialog
                open={featureDialogOpen}
                onClose={handleCloseFeatureDialog}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        margin: { xs: 2, sm: 'auto' },
                        width: { xs: 'calc(100% - 32px)', sm: '100%' }
                    }
                }}
            >
                <DialogTitle sx={{
                    borderBottom: '1px solid #D1D4DB',
                    ...styles.dialogTitle,
                    fontSize: '20px',
                    fontWeight: '600'
                }}>
                    Get your venture featured in FLAME
                </DialogTitle>
                <DialogContent sx={{ mt: 2, p: 3 }}>
                    <Typography sx={{ ...styles.fieldLabel, mb: 1 }}>
                        Subject<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Interested in your products..."
                        value={featureSubject}
                        onChange={(e) => setFeatureSubject(e.target.value)}
                        variant="outlined"
                        sx={styles.textField}
                        required
                    />

                    <Typography sx={{ ...styles.fieldLabel, mb: 1, mt: 3 }}>
                        Your message<Box component="span" sx={{ color: 'error.main' }}>*</Box>
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Write your message here..."
                        value={featureMessage}
                        onChange={(e) => setFeatureMessage(e.target.value)}
                        variant="outlined"
                        sx={styles.textField}
                        required
                    />
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 1, justifyContent: 'flex-end' }}>
                    <Button
                        onClick={handleCloseFeatureDialog}
                        sx={{
                            ...styles.fieldLabel,
                            color: 'text.secondary',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleFeatureRequestSubmit}
                        variant="contained"
                        sx={{
                            textTransform: 'none',
                            padding: '8px 22px',
                            borderRadius: '8px',
                            color: "#000000",
                            background: 'linear-gradient(to right, #FFD966, #F9B200)',
                            '&:hover': {
                                background: 'linear-gradient(to right, #F9B200, #FFD966)',
                            },
                        }}
                    >
                        Raise request
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={promotionStatusDialogOpen}
                onClose={() => setPromotionStatusDialogOpen(false)}
                PaperProps={{ sx: { borderRadius: '16px', p: 2, minWidth: 340 } }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                    <Typography sx={{ fontWeight: 500, fontSize: 20, color: '#373A45' }}>
                        {promotionStatusMessage}
                    </Typography>
                    <IconButton onClick={() => setPromotionStatusDialogOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                {promotionStatusMessage === 'Your business promotion is already live.' && (
                    <Typography sx={{ color: '#373A45', fontSize: 16, mt: 1 }}>
                        You can deactivate it instead.
                    </Typography>
                )}
            </Dialog>
        </Box>
    );
};

// Helper functions for localStorage timestamp
const getInterestTimestamp = (businessId: string) => {
    const key = `interestTimestamp_${businessId}`;
    const value = localStorage.getItem(key);
    return value ? parseInt(value, 10) : null;
};
const setInterestTimestamp = (businessId: string) => {
    const key = `interestTimestamp_${businessId}`;
    localStorage.setItem(key, Date.now().toString());
};
const clearInterestTimestamp = (businessId: string) => {
    const key = `interestTimestamp_${businessId}`;
    localStorage.removeItem(key);
};
const isThreeDaysPassed = (timestamp: number | null) => {
    if (!timestamp) return true;
    const now = Date.now();
    return now - timestamp > 3 * 24 * 60 * 60 * 1000;
};

export default BusinessDetailPage;
